import React from 'react';
import { Button, List, ListItem, Typography } from 'drift-ui';
import { useDispatch } from 'react-redux';
import {
  BOOKIT_NOW_PERMISSION,
  getPermissionsLevel,
  openPermissionDialog,
} from '../../../services/freightPermissionService';
import { RootState, useAppSelector } from '../../../store';
import styles from './faqStyles.scss';
import { useTranslation, Trans } from 'react-i18next';

const FreightFaqContainer = () => {
  const dispatch = useDispatch();
  const { data } = useAppSelector((state: RootState) => state.carrierPermissionsData);
  const { user } = useAppSelector((state) => state.adminShell);
  const { t } = useTranslation('common', { keyPrefix: 'contact_us_page' });

  const userHasFullAccess = user.permissions.includes(BOOKIT_NOW_PERMISSION);

  const companyPermissionLevel = data && getPermissionsLevel(data.companyPermissions);

  const userPermissionsLevel = getPermissionsLevel(user.permissions);

  const hasFreightAccess = companyPermissionLevel !== 'No Freight' || userPermissionsLevel !== 'No Freight';

  const showFreightAccess = hasFreightAccess && !userHasFullAccess;

  return (
    <>
      <Typography className={styles.listText}>{t('freight_access_tiers_description')}</Typography>
      <List>
        <ListItem disablePadding>
          <Typography className={styles.boldText}>{t('freight_no_access')}</Typography>
        </ListItem>
        <ListItem disablePadding className={styles.listItem}>
          <Typography className={styles.listText}>{t('freight_tier_no_access_description')}</Typography>
        </ListItem>
        <ListItem disablePadding>
          <Typography className={styles.boldText}>{t('freight_view_only_access')}</Typography>
        </ListItem>
        <ListItem disablePadding className={styles.listItem}>
          <Trans
            i18nKey={t('freight_view_loads_warning')}
            components={[
              <Typography className={styles.listText} component={'span'} key="0" />,
              <Typography className={styles.linkText} component={'a'} href="https://highway.com/" key="1" />,
            ]}
          />
        </ListItem>
        <ListItem disablePadding>
          <Typography className={styles.boldText}>{t('freight_full_access')}</Typography>
        </ListItem>
        <ListItem disablePadding className={styles.listItem}>
          <Typography className={styles.listText}>{t('freight_full_access_description')}</Typography>
        </ListItem>
        <ListItem disablePadding>
          <Typography className={styles.boldText}>{t('freight_permissions_title')}</Typography>
        </ListItem>
        <ListItem disablePadding className={styles.blueMarker}>
          <Typography className={styles.blueText} component={'span'}>
            {t('freight_carrier')}
          </Typography>
          <Typography className={styles.listText} component={'span'}>
            {companyPermissionLevel as string}
          </Typography>
        </ListItem>
        <div>
          <ListItem disablePadding className={styles.blueMarker}>
            <Typography className={styles.blueText} component={'span'}>
              {`${user.firstname} ${user.lastname}:`}
            </Typography>
            <Typography className={styles.paddedText} component={'span'}>
              {`${userPermissionsLevel}`}
            </Typography>
          </ListItem>
          {showFreightAccess ? (
            <>
              <ListItem disablePadding className={styles.listItem}>
                <Typography className={styles.listText}>{t('freight_contact_elevated_access')}</Typography>
              </ListItem>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatch(openPermissionDialog());
                }}
              >
                Request access
              </Button>
            </>
          ) : null}
        </div>
      </List>
    </>
  );
};

export default FreightFaqContainer;
